// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Schedule {
  margin-top: 20px;
}
.Schedule .month-selector {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding: 16px 20px;
  background: #41424C;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(65, 66, 76, 0.2);
}
.Schedule .month-selector span {
  font-weight: 600;
  color: white;
  font-size: 16px;
}
.Schedule .month-selector select {
  padding: 8px 16px;
  border-radius: 8px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
}
.Schedule .month-selector select:hover {
  border-color: rgba(255, 255, 255, 0.5);
  background: rgb(255, 255, 255);
}
.Schedule .month-selector select:focus {
  outline: none;
  border-color: white;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);
}
.Schedule .Schedule-monthly .monthly-week {
  margin-bottom: 30px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.Schedule .Schedule-monthly .monthly-week .week-header {
  background: #41424C;
  color: white;
  padding: 16px 20px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban {
  display: flex;
  gap: 0;
  min-height: 300px;
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: #41424C #f0f0f0;
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban::-webkit-scrollbar {
  height: 8px;
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 4px;
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban::-webkit-scrollbar-thumb {
  background: #41424C;
  border-radius: 4px;
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban::-webkit-scrollbar-thumb:hover {
  background: rgb(41.4893617021, 42.1276595745, 48.5106382979);
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column {
  flex: 0 0 200px;
  min-width: 200px;
  padding: 16px 12px;
  border-right: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  position: relative;
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column:last-child {
  border-right: none;
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column:hover {
  background: rgba(65, 66, 76, 0.02);
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column .title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 16px;
  padding: 8px 4px;
  border-radius: 8px;
  background: #41424C;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column .ScheduleBlock {
  background: white;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-left: 4px solid #41424C;
  transition: all 0.3s ease;
  cursor: pointer;
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column .ScheduleBlock:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(65, 66, 76, 0.15);
  border-left-color: rgb(41.4893617021, 42.1276595745, 48.5106382979);
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column .ScheduleBlock .scheduleblock-time {
  font-size: 12px;
  font-weight: 600;
  color: #41424C;
  margin-bottom: 6px;
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column .ScheduleBlock .scheduleblock-subject {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column .ScheduleBlock .scheduleblock-group {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column .ScheduleBlock .scheduleblock-comment {
  font-size: 11px;
  color: #555;
  font-weight: 500;
  margin-bottom: 12px;
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column .ScheduleBlock button {
  margin-top: 12px;
  padding: 6px 12px;
  background: #41424C;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column .ScheduleBlock button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(65, 66, 76, 0.3);
  background: rgb(41.4893617021, 42.1276595745, 48.5106382979);
}
.Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column .empty-day {
  color: #999;
  text-align: center;
  font-size: 12px;
  padding: 20px 8px;
  font-style: italic;
}
@media (max-width: 768px) {
  .Schedule .Schedule-monthly .monthly-week .Schedule-kanban {
    gap: 0;
    overflow-x: scroll;
  }
  .Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column {
    flex: 1 1;
    border-right: none;
    border-bottom: 1px solid #f0f0f0;
    padding: 12px 8px;
    width: 300px !important;
  }
  .Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column:last-child {
    border-bottom: none;
  }
  .Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column .title {
    font-size: 12px;
    padding: 6px 2px;
  }
  .Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column .ScheduleBlock {
    padding: 8px;
    margin-bottom: 8px;
  }
  .Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column .ScheduleBlock .scheduleblock-time {
    font-size: 11px;
  }
  .Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column .ScheduleBlock .scheduleblock-subject {
    font-size: 13px;
  }
  .Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column .ScheduleBlock .scheduleblock-comment {
    font-size: 10px;
    margin-bottom: 10px;
  }
  .Schedule .Schedule-monthly .monthly-week .Schedule-kanban .Schedule__column .ScheduleBlock button {
    padding: 4px 8px;
    font-size: 10px;
    margin-top: 10px;
  }
}
@media (max-width: 768px) {
  .Schedule .month-selector {
    flex-direction: column;
    gap: 8px;
    padding: 12px 16px;
  }
  .Schedule .month-selector select {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/Schedule.scss"],"names":[],"mappings":"AAGA;EACI,gBAAA;AAFJ;AAKI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAZQ;EAaR,mBAAA;EACA,4CAAA;AAHR;AAKQ;EACI,gBAAA;EACA,YAAA;EACA,eAAA;AAHZ;AAMQ;EACI,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;AAJZ;AAMY;EACI,sCAAA;EACA,8BAAA;AAJhB;AAOY;EACI,aAAA;EACA,mBAAA;EACA,8CAAA;AALhB;AAYQ;EACI,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;AAVZ;AAYY;EACI,mBAxDA;EAyDA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AAVhB;AAaY;EACI,aAAA;EACA,MAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gCAAA;AAXhB;AAagB;EACI,WAAA;AAXpB;AAcgB;EACI,mBAAA;EACA,kBAAA;AAZpB;AAegB;EACI,mBAnFJ;EAoFI,kBAAA;AAbpB;AAgBgB;EACI,4DAAA;AAdpB;AAiBgB;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,+BAAA;EACA,yBAAA;EACA,kBAAA;AAfpB;AAiBoB;EACI,kBAAA;AAfxB;AAkBoB;EACI,kCAAA;AAhBxB;AAmBoB;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAnHR;EAoHQ,YAAA;EACA,yCAAA;AAjBxB;AAqBoB;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;AAnBxB;AAqBwB;EACI,2BAAA;EACA,6CAAA;EACA,mEAAA;AAnB5B;AAsBwB;EACI,eAAA;EACA,gBAAA;EACA,cA5IZ;EA6IY,kBAAA;AApB5B;AAuBwB;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AArB5B;AAwBwB;EACI,eAAA;EACA,WAAA;EACA,kBAAA;AAtB5B;AAyBwB;EACI,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAvB5B;AA2BwB;EACI,gBAAA;EACA,iBAAA;EACA,mBAxKZ;EAyKY,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAzB5B;AA2B4B;EACI,2BAAA;EACA,2CAAA;EACA,4DAAA;AAzBhC;AA+BoB;EACI,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA7BxB;AAmCY;EACI;IACI,MAAA;IACA,kBAAA;EAjClB;EAmCkB;IACI,SAAA;IACA,kBAAA;IACA,gCAAA;IACA,iBAAA;IACA,uBAAA;EAjCtB;EAmCsB;IACI,mBAAA;EAjC1B;EAoCsB;IACI,eAAA;IACA,gBAAA;EAlC1B;EAqCsB;IACI,YAAA;IACA,kBAAA;EAnC1B;EAqC0B;IACI,eAAA;EAnC9B;EAsC0B;IACI,eAAA;EApC9B;EAuC0B;IACI,eAAA;IACA,mBAAA;EArC9B;EAwC0B;IACI,gBAAA;IACA,eAAA;IACA,gBAAA;EAtC9B;AACF;AA+CI;EACI;IACI,sBAAA;IACA,QAAA;IACA,kBAAA;EA7CV;EA+CU;IACI,WAAA;EA7Cd;AACF","sourcesContent":["// Стили для месячного расписания на странице Home\n$primary-color: #41424C;\n\n.Schedule {\n    margin-top: 20px;\n\n    // Селектор месяца\n    .month-selector {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        margin-bottom: 24px;\n        padding: 16px 20px;\n        background: $primary-color;\n        border-radius: 12px;\n        box-shadow: 0 4px 15px rgba(65, 66, 76, 0.2);\n\n        span {\n            font-weight: 600;\n            color: white;\n            font-size: 16px;\n        }\n\n        select {\n            padding: 8px 16px;\n            border-radius: 8px;\n            border: 2px solid rgba(255, 255, 255, 0.3);\n            background: rgba(255, 255, 255, 0.9);\n            font-size: 14px;\n            font-weight: 500;\n            color: #333;\n            cursor: pointer;\n            transition: all 0.3s ease;\n\n            &:hover {\n                border-color: rgba(255, 255, 255, 0.5);\n                background: rgba(255, 255, 255, 1);\n            }\n\n            &:focus {\n                outline: none;\n                border-color: white;\n                box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);\n            }\n        }\n    }\n\n    // Месячное расписание\n    .Schedule-monthly {\n        .monthly-week {\n            margin-bottom: 30px;\n            background: white;\n            border-radius: 16px;\n            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n            overflow: hidden;\n\n            .week-header {\n                background: $primary-color;\n                color: white;\n                padding: 16px 20px;\n                font-size: 16px;\n                font-weight: 600;\n                text-align: center;\n                text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n            }\n\n            .Schedule-kanban {\n                display: flex;\n                gap: 0;\n                min-height: 300px;\n                overflow-x: auto;\n                scrollbar-width: thin;\n                scrollbar-color: $primary-color #f0f0f0;\n\n                &::-webkit-scrollbar {\n                    height: 8px;\n                }\n\n                &::-webkit-scrollbar-track {\n                    background: #f0f0f0;\n                    border-radius: 4px;\n                }\n\n                &::-webkit-scrollbar-thumb {\n                    background: $primary-color;\n                    border-radius: 4px;\n                }\n\n                &::-webkit-scrollbar-thumb:hover {\n                    background: darken($primary-color, 10%);\n                }\n\n                .Schedule__column {\n                    flex: 0 0 200px;\n                    min-width: 200px;\n                    padding: 16px 12px;\n                    border-right: 1px solid #f0f0f0;\n                    transition: all 0.3s ease;\n                    position: relative;\n\n                    &:last-child {\n                        border-right: none;\n                    }\n\n                    &:hover {\n                        background: rgba(65, 66, 76, 0.02);\n                    }\n\n                    .title {\n                        font-size: 14px;\n                        font-weight: 600;\n                        color: #333;\n                        text-align: center;\n                        margin-bottom: 16px;\n                        padding: 8px 4px;\n                        border-radius: 8px;\n                        background: $primary-color;\n                        color: white;\n                        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n                    }\n\n                    // Стили для блоков занятий\n                    .ScheduleBlock {\n                        background: white;\n                        border-radius: 12px;\n                        padding: 12px;\n                        margin-bottom: 12px;\n                        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n                        border-left: 4px solid $primary-color;\n                        transition: all 0.3s ease;\n                        cursor: pointer;\n\n                        &:hover {\n                            transform: translateY(-2px);\n                            box-shadow: 0 4px 16px rgba(65, 66, 76, 0.15);\n                            border-left-color: darken($primary-color, 10%);\n                        }\n\n                        .scheduleblock-time {\n                            font-size: 12px;\n                            font-weight: 600;\n                            color: $primary-color;\n                            margin-bottom: 6px;\n                        }\n\n                        .scheduleblock-subject {\n                            font-size: 14px;\n                            font-weight: 600;\n                            color: #333;\n                            margin-bottom: 4px;\n                        }\n\n                        .scheduleblock-group {\n                            font-size: 12px;\n                            color: #666;\n                            margin-bottom: 4px;\n                        }\n\n                        .scheduleblock-comment {\n                            font-size: 11px;\n                            color: #555;\n                            font-weight: 500;\n                            margin-bottom: 12px;\n                        }\n\n                        // Стили для кнопки\n                        button {\n                            margin-top: 12px;\n                            padding: 6px 12px;\n                            background: $primary-color;\n                            color: white;\n                            border: none;\n                            border-radius: 6px;\n                            font-size: 11px;\n                            font-weight: 500;\n                            cursor: pointer;\n                            transition: all 0.3s ease;\n\n                            &:hover {\n                                transform: translateY(-1px);\n                                box-shadow: 0 2px 8px rgba(65, 66, 76, 0.3);\n                                background: darken($primary-color, 10%);\n                            }\n                        }\n                    }\n\n                    // Стили для пустых дней\n                    .empty-day {\n                        color: #999;\n                        text-align: center;\n                        font-size: 12px;\n                        padding: 20px 8px;\n                        font-style: italic;\n                    }\n                }\n            }\n\n            // Адаптивность для мобильных устройств\n            @media (max-width: 768px) {\n                .Schedule-kanban {\n                    gap: 0;\n                    overflow-x: scroll;\n\n                    .Schedule__column {\n                        flex: 1;\n                        border-right: none;\n                        border-bottom: 1px solid #f0f0f0;\n                        padding: 12px 8px;\n                        width: 300px !important;\n\n                        &:last-child {\n                            border-bottom: none;\n                        }\n\n                        .title {\n                            font-size: 12px;\n                            padding: 6px 2px;\n                        }\n\n                        .ScheduleBlock {\n                            padding: 8px;\n                            margin-bottom: 8px;\n\n                            .scheduleblock-time {\n                                font-size: 11px;\n                            }\n\n                            .scheduleblock-subject {\n                                font-size: 13px;\n                            }\n\n                            .scheduleblock-comment {\n                                font-size: 10px;\n                                margin-bottom: 10px;\n                            }\n\n                            button {\n                                padding: 4px 8px;\n                                font-size: 10px;\n                                margin-top: 10px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    // Адаптивность для мобильных устройств\n    @media (max-width: 768px) {\n        .month-selector {\n            flex-direction: column;\n            gap: 8px;\n            padding: 12px 16px;\n\n            select {\n                width: 100%;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
